"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.checkAccessToken = checkAccessToken;
exports.setHttpBaseURL = setHttpBaseURL;
exports.setupAuthHttpService = setupAuthHttpService;
exports.setupAuthHttpServiceServer = setupAuthHttpServiceServer;
exports.setupHttpHeaders = setupHttpHeaders;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _nookies = require("nookies");
var _auth = _interopRequireDefault(require("../interceptors/auth.interceptor"));
var _authServer = _interopRequireDefault(require("../interceptors/auth-server.interceptor"));
var _constants2 = require("../constants");
var _auth2 = require("../clients/auth.client");
var _authSsr = _interopRequireDefault(require("../interceptors/auth-ssr.interceptor"));
function setHttpBaseURL(apiBaseURL) {
  _http.$http.formatBaseUrl(apiBaseURL);
}
function setupHttpHeaders(language, apiToken, platform, userToken) {
  _http.$http.addHeaders({
    'x-platform': platform,
    'x-bt': platform,
    // used in HUB
    'x-locale': language,
    'Accept-Language': language === _constants.LANGUAGE.AR ? 'ar_SA' : 'en_US',
    // cache headers to support ie 11 polling
    'Cache-Control': 'private, no-cache, no-store, must-revalidate',
    Expires: '-1',
    Pragma: 'no-cache',
    'x-authorization': `Bearer ${apiToken}`,
    ...(userToken && {
      Authorization: `Bearer ${userToken}`
    })
  });
}
async function setupAuthHttpService(platform, ctx, $httpService) {
  let token = null;
  _http.$http.addHeaders({
    'x-platform': platform
  });
  if (ctx) {
    _http.$http.addInterceptor({
      request: _authSsr.default.request(ctx)
    });
    const expires_in_cookie = (0, _nookies.parseCookies)(ctx)[_constants2.STORAGE_KEYS.TOKEN_EXPIRY];
    if (expires_in_cookie) {
      let expires_in = parseInt(expires_in_cookie, 10);
      expires_in -= Date.now();
      if (expires_in <= _constants2.REFRESH_EXPIRY_TIMER) {
        const response = await _auth2.AuthClient.refreshToken(ctx);
        if (response.access_token) {
          token = response.access_token;
          _http.$http.addHeaders({
            Authorization: `Bearer ${token}`
          });
        }
      }
    }
  } else {
    _http.$http.addInterceptor({
      request: _auth.default.request,
      responseError: _auth.default.responseError
    });
    if ($httpService) {
      $httpService.addInterceptor({
        request: _auth.default.request,
        responseError: _auth.default.responseError
      });
    }
  }
  return token;
}
function setupAuthHttpServiceServer(platform, ctx, $httpService) {
  _http.$http.addHeaders({
    'x-platform': platform
  });
  _http.$http.addInterceptor({
    request: _authServer.default.request(ctx)
  });
  if ($httpService) {
    $httpService.addInterceptor({
      request: _authServer.default.request(ctx)
    });
  }
}
async function checkAccessToken({
  ctx,
  $httpService,
  platform = 'mweb',
  REFRESH_TOKEN_URL,
  silentLogout
}) {
  const expires_in_cookie = (0, _nookies.parseCookies)(ctx)[_constants2.STORAGE_KEYS.TOKEN_EXPIRY];
  _http.$http.formatBaseUrl(REFRESH_TOKEN_URL);
  _http.$http.addHeaders({
    'x-platform': platform
  });
  if (expires_in_cookie) {
    let expires_in = parseInt(expires_in_cookie, 10);
    expires_in -= Date.now();
    if (expires_in <= _constants2.REFRESH_EXPIRY_TIMER) {
      const response = await _auth2.AuthClient.refreshToken(ctx, false, silentLogout ? $httpService : false);
      if (response.access_token) {
        const token = response.access_token;
        _http.$http.addHeaders({
          Authorization: `Bearer ${token}`
        });
        if ($httpService) {
          $httpService.addHeaders({
            Authorization: `Bearer ${token}`
          });
        }
        return false;
      }
      return true;
    }
  }
  return false;
}